import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "氏名"),
  /*#__PURE__*/_createElementVNode("div", { class: "resume-icon-wrapper --auto-right1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "履"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "職")
  ])
], -1)
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = { class: "p-recommend-form__group-1" }
const _hoisted_5 = { class: "p-recommend-form__group-1-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("氏名"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_7 = { class: "p-recommend-form__kana-fields" }
const _hoisted_8 = { class: "p-recommend-form__group-1-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("氏名カナ"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_10 = { class: "p-recommend-form__kana-fields" }
const _hoisted_11 = { class: "p-recommend-form__field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "生年月日"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_13 = { class: "p-recommend-form__error-wrap" }
const _hoisted_14 = { class: "p-recommend-form__group-1" }
const _hoisted_15 = { class: "p-recommend-form__group-1-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("生年月日"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_17 = { class: "p-recommend-form__group-1-birth" }
const _hoisted_18 = { class: "p-recommend-form__field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "性別"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_20 = { class: "p-recommend-form__field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "電話番号"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_22 = { class: "p-recommend-form__error-wrap" }
const _hoisted_23 = { class: "p-recommend-form__group-1" }
const _hoisted_24 = { class: "p-recommend-form__group-1-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("電話番号1"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_26 = { class: "p-recommend-form__group-1-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "電話番号2", -1)
const _hoisted_28 = { class: "p-recommend-form__field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_30 = { class: "p-recommend-form__group-1" }
const _hoisted_31 = {
  key: 0,
  class: "p-recommend-form__group-1-field"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, [
  /*#__PURE__*/_createTextVNode("メールアドレス1"),
  /*#__PURE__*/_createElementVNode("span", { class: "-is-required" }, "必須")
], -1)
const _hoisted_33 = { class: "p-recommend-form__text-1" }
const _hoisted_34 = { class: "p-recommend-form__group-1-field" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "メールアドレス2", -1)
const _hoisted_36 = { class: "p-recommend-form__text-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-text-1" }, "ログインIDまたはメールアドレスを変更する場合はこちら", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  class: "p-recommend-button --type-2 --has-icon --width-3",
  href: "/mail_security/form/"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "変更画面へ")
], -1)
const _hoisted_39 = { class: "p-recommend-form__field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ログインID")
], -1)
const _hoisted_41 = { class: "p-recommend-form__text-1" }

import InvalidMessage from '@/components/InvalidMessage.vue';
import ValidatableField from '@/components/ValidatableField.vue';
import YearMonthDaySelect from '../components/YearMonthDaySelect.vue';
import ResumeSelect from '../components/ResumeSelect.vue';

type Props = {
    openModal: () => void,
    mypageId: string;
    emailHome: string;
    emailCellular: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalInfoForm',
  props: {
    openModal: null,
    mypageId: null,
    emailHome: null,
    emailCellular: null
  },
  setup(__props: any) {




const currentYear = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InvalidMessage, { name: "lastName" }),
        _createVNode(InvalidMessage, { name: "firstName" }),
        _createVNode(InvalidMessage, { name: "lastNameKana" }),
        _createVNode(InvalidMessage, { name: "firstNameKana" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-name",
              type: "text",
              name: "lastName",
              placeholder: "例）毎日",
              label: "氏名（姓）",
              rules: "required|max:50",
              maxlength: "50"
            }),
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-name",
              type: "text",
              name: "firstName",
              placeholder: "例）太郎",
              label: "氏名（名）",
              rules: "required|max:50",
              maxlength: "50"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-name-kana-last",
              type: "text",
              name: "lastNameKana",
              placeholder: "例）マイニチ",
              label: "氏名カナ（姓）",
              rules: "required|zen_kana|max:50",
              maxlength: "50"
            }),
            _createVNode(ValidatableField, {
              class: "p-recommend-form__modal-input-2",
              id: "form-name-kana-first",
              type: "text",
              name: "firstNameKana",
              placeholder: "例）タロウ",
              label: "氏名カナ（名）",
              rules: "required|zen_kana|max:50",
              maxlength: "50"
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(InvalidMessage, { name: "birthDateY" }),
        _createVNode(InvalidMessage, { name: "birthDateM" }),
        _createVNode(InvalidMessage, { name: "birthDateD" })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(YearMonthDaySelect, {
              name: { year: `birthDateY`, month: `birthDateM`, day: `birthDateD` },
              label: "生年月日",
              "max-year": _unref(currentYear) - 18,
              "min-year": _unref(currentYear) - 100
            }, null, 8, ["max-year", "min-year"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode(ResumeSelect, {
        name: "sexFlg",
        label: "選択",
        id: "sex",
        className: "p-recommend-form__select"
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createVNode(InvalidMessage, { name: "telHome" }),
        _createVNode(InvalidMessage, { name: "telCellular" })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(ValidatableField, {
            class: "p-recommend-form__modal-input-2",
            id: "form-phone-1",
            type: "text",
            name: "telHome",
            placeholder: "例）99999999999",
            label: "自宅TEL",
            rules: "required|max:20|tel",
            maxlength: "20"
          })
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode(ValidatableField, {
            class: "p-recommend-form__modal-input-2",
            id: "form-phone-2",
            type: "text",
            name: "telCellular",
            placeholder: "例）99999999999",
            label: "携帯TEL",
            rules: "max:20|nullableTel",
            maxlength: "20"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        (__props.emailHome)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("p", _hoisted_33, _toDisplayString(__props.emailHome), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("p", _hoisted_36, _toDisplayString(__props.emailCellular || '未設定'), 1)
        ]),
        _hoisted_37,
        _hoisted_38
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _hoisted_40,
      _createElementVNode("p", _hoisted_41, [
        _createTextVNode(_toDisplayString(__props.mypageId) + " ", 1),
        _createElementVNode("button", {
          class: "p-recommend-help js-modal-open-button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (__props.openModal && __props.openModal(...args)), ["prevent"]))
        }, "?")
      ])
    ])
  ], 64))
}
}

})